import type { Testimonial } from '../testimonials'

export const added: Testimonial = {
  company: 'Netafim',
  logo: { name: 'Netafim', src: '/logo/netafimcard.png' },
  portrait: { src: '/photo/portrait-benny-klener.png', alt: 'Benny Klener' },
  quote: [
    'Programa utilizing Digitopia platform conducted an Operations Digital Maturity Index '
    + '(OMI) analysis for Netafim operations. OMI supported us to align our current and '
    + 'future digital initiatives to our current needs and operation strategy. OMI provides '
    + 'us with a management tool to priorities our investments in digital transformation and '
    + 'monitor them.',
  ],
  attribution: 'Benny Klener, Senior Vice President, Head of Global Operations',
  story: 'netafim',
}

/** Its place on the wall — the order the live page lists them in. */
export const order = 14
